import { useState, useRef } from "react";

const OtpInp = ({ length = 5, onComplete }) => {
    const [otp, setOtp] = useState(Array(length).fill(""));
    const inputRefs = useRef([]);

    const convertToEnglishDigits = (str) => {
        return str.replace(/[۰-۹]/g, (d) =>
            "۰۱۲۳۴۵۶۷۸۹".indexOf(d)
        );
    };

    const handleChange = (index, value) => {
        value = convertToEnglishDigits(value);

        if (!/^[0-9]?$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;

        setOtp(newOtp);

        if (value && index < length - 1) {
            inputRefs.current[index + 1]?.focus();
        }

        if (newOtp.every((num) => num !== "") && onComplete) {
            onComplete(newOtp.join(""));
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === "Backspace") {
            if (otp[index]) {
                const newOtp = [...otp];
                newOtp[index] = "";
                setOtp(newOtp);
            } else if (index > 0) {
                inputRefs.current[index - 1]?.focus();
            }
        }

        if (e.key === "ArrowLeft" && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }

        if (e.key === "ArrowRight" && index < length - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    return (
        <div className="ltr flex gap-2 justify-center" dir="ltr">
            {otp.map((digit, index) => (
                <input
                    key={index}
                    ref={(el) => {
                        inputRefs.current[index] = el;
                    }}
                    type="text"
                    inputMode="numeric"
                    autoComplete={index === 0 ? "one-time-code" : "off"}
                    pattern="[0-9]*"
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    className="
                        w-12 h-12
                        text-center
                        text-xl
                        font-bold

                        border border-white/70
                        bg-white/60
                        backdrop-blur-md
                        rounded-xl

                        text-gray-800
                        placeholder:text-gray-400

                        focus:outline-none
                        focus:ring-2
                        focus:ring-yellow-300
                        focus:border-teal-300
                        focus:bg-white/80

                        transition-all duration-200

                        dark:!border-teal-300/30
                        dark:!bg-teal-900/40
                        dark:!text-teal-50
                        dark:!placeholder:text-teal-200/40
                        dark:!focus:ring-yellow-300/70
                        dark:!focus:border-teal-300
                        dark:!focus:bg-teal-900/60
                    "
                />
            ))}
        </div>
    );
};

export default OtpInp;